module.exports = __webpack_public_path__ + "img/direct-sales-incentive.2367b2c.webp";